import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Wrapper do Formly que agrupa um conjunto de campos num fieldset com legenda
 * (substitui o p-fieldset do PrimeNG por fieldset/legend nativos estilizados).
 * Puramente visual: a legenda vem de props.label (ex.: displayName da step, já
 * presente na metadata) — nada é persistido. O grid/espaçamento dos campos é
 * controlado por fieldGroupClassName no próprio grupo.
 */
@Component({
  selector: 'evolve-fieldset-wrapper',
  template: `
    <fieldset class="mb-4 rounded-lg border border-border px-4 pb-4 pt-1">
      <legend
        class="px-2 text-sm font-semibold text-foreground"
      >
        {{ props.label ?? '' }}
      </legend>
      <ng-container #fieldComponent />
    </fieldset>
  `,
})
export class FieldsetWrapperComponent extends FieldWrapper<FormlyFieldConfig> {}
